import {qspost} from '@/plugins/axios'

/*
 * 分会详情
  * * @constructor jack
 * */
export const showOrgFenHui = (id) => qspost('Admin/User/showOrgFenHui', {
    id
})

/*
 * 统计用户的 会员数量   待审核数量   待续费数量
 * @constructor jack
 * */
export const tongJiUserNumber = () => qspost('/Admin/tongji/tongJiUserNumberFh', {})

/*
 * 会员人数统计
 * @constructor jack
 * */
export const getUserNumberStatistics = () => qspost('/Admin/tongji/getUserNumberStatisticsFh', {})


/*
 * 会员人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsPersonal = () => qspost('/Admin/tongji/getUserNumberStatisticsPersonalFh', {})


/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsByRegion = () => qspost('/Admin/tongji/getUserNumberStatisticsByRegionFh', {})



/*
 * 会员地区人数统计
 * @constructor jack
 * */
export const getUserNumberStatisticsByRegionPersonal = () => qspost('/Admin/tongji/getUserNumberStatisticsByRegionPersonalFh', {})



/*
 * 会员等级统计
 * @constructor jack
 * */
export const getUserGradeStatistics = () => qspost('/Admin/tongji/getUserGradeStatisticsFh', {})

/*
 * 会员续费统计
 * @constructor jack
 * */
export const userRenewStatistics = () => qspost('/Admin/tongji/userRenewStatisticsFh', {})


/*
 * 会员续费统计
 * @constructor jack
 * */
export const userRenewStatisticsPersonal = () => qspost('/Admin/tongji/userRenewStatisticsPersonalFh', {})



/*
 * 统计机构数据  通知公告、机构动态、活动管理、服务申请
 * @constructor jack
 * */
export const jiGouShuJu = () => qspost('/Admin/tongji/jiGouShuJuFh', {})


/*
 * 通知公告-列表
 * @constructor jack
 * */
export const noticeList = (page, limit, keyword) => qspost('/Admin/Notice/getListFh', {page, limit, keyword})

/*
 * 通知公告-未读人员列表
 * @constructor jack
 * */
export const getNotReadList = (id, type) => qspost('/Admin/Notice/getNotReadListFh', {id, type})

/*
 * 通知公告-未读人员提醒
 * @constructor jack
 * */
export const noticeRemind = (id, user_id) => qspost('/Admin/Notice/remindFh', {id, user_id})


/*
 *  通知公告列表
 * @constructor jack
 * */

export const getNoticeList = (page,limit) => qspost('Home/Notice/getLIstFh', {page,limit})

/*
 *  首页通知公告详情
 * @constructor jack
 * */

export const getNoticeDetail = (id) => qspost('Home/Notice/detailFh', {id})

/*
 *  2反馈提交
 * @constructor jack
 * */

export const feedbackNotice = (id,content) => qspost('Home/Notice/feedbackFh', {id,content})

/*
 * 通知公告-发布
 * @constructor jack
 * */
export const noticeAdd = (title,is_feedback,content,fileJson,ids,feedbackJson
) => qspost('/admin/Notice/setInfoFh', {title,is_feedback,content,fileJson,ids,feedbackJson})

/*
 * 通知公告-修改
 * @constructor jack
 * */
export const noticeEdit = (title,content,fileJson,ids,id) => qspost('/Admin/Notice/setInfoFh', {title,content,fileJson,ids,id})

/*
 * 通知公告-删除
 * @constructor jack
 * */
export const noticeDel = (id) => qspost('/Admin/Notice/delFh', {id})


/*
 * 短信发送-列表
 * @constructor jack
 * */
export const messageList = () => qspost('/Admin/Sendsms/send_sms_logFh', {})

/*
 * 短信发送-删除功能
 * @constructor jack
 * */
export const delSendSmsLog = (id) => qspost('/Admin/Sendsms/delSendSmsLog', {id})


/*
 * 短信发送-列表
 * @constructor jack
 * */
export const getSendSMSUserList = (orderId) => qspost('/Admin/Sendsms/getSendSMSUserListFh', {orderId})

/*
 * 短信发送-短信模版获取
 * @constructor jack
 * */
export const getSmsDemoList = () => qspost('/Admin/Sendsms/smsListFh', {})

/*
 * 短信发送-短信发送
 * @constructor jack
 * */
export const sendMessage = (message,template_id,user_id,delSMSNum) => qspost('/Admin/Sendsms/sendMessageFh',
    {message,template_id,user_id,delSMSNum})

/*
 * 获得短信的剩余条数
 * @constructor jack
 * */
export const getSMSShengYuNumber = () => qspost('/admin/Sendsms/getSMSShengYuNumber', {})


/*
 * 通知公告-详情
 * @constructor jack
 * */
export const noticeDetail = (id) => qspost('/Admin/Notice/detailFh', {id})

/*
 * 通知公告-反馈
 * @constructor jack
 * */
export const getNoticeFeedback = (isFeedback,searchKey,id) => qspost('/Admin/Notice/getFeedbackFh', {isFeedback,searchKey,id})

/*
 * 通知公告-标签选择
 * @constructor jack
 * */
export const labelSelect =() => qspost('/Admin/Customlable/getOrgToUserLableAllFh', {})



/*
 * 机构信息
  * * @constructor jack
 * */
export const getParentInfo = () => qspost('Admin/Index/getParentInfoFh', {})

/*
 *  机构介绍
 * @constructor jack
 * */

export const getOrganizInfo = () => qspost('Home/User/getParentInfoFh', {})


/*会员设置*/
/*
 * 级别管理-列表
 * @constructor jack
 * */
export const getRankList = (user_type) => qspost('/Admin/User/getRankListFh', {user_type})

/*
* 信息管理-自定义表单获取
*
* */
export const getRankListFH = (type) => qspost('/Admin/User/getRankList', {type})


/*
 * 级别管理-添加
 * @constructor jack
 * */
export const setRank = (name, price, id = '') => qspost('/Admin/User/setRankFh', {name, price, id})
/*
 * 级别管理-删除
 * @constructor jack
 * */
export const delRank = (id) => qspost('/Admin/User/delRankFh', {id})


export const allMember = (id, user_id) => qspost('/Admin/User/getListAllUserFH', {id, user_id})

/*
 * 标签管理-自定义标签列表
 * @constructor jack
 * */
export const customList = () => qspost('/Admin/Customlable/getRankListFh', {})

/*
 * 标签管理-内置标签详情
 * @constructor jack
 * */
export const labelDetail = (rankId,type = 2) => qspost('/Admin/User/getRankUserListFh', {rankId,type})

export const getUserFixedLableByFixedId = (fixedId) => qspost('/Admin/Customlable/getUserFixedLableByFixedIdFh', {fixedId})

/*
 * 标签管理-自定义标签详情
 * @constructor jack
 * */
export const customDetail = (lableId) => qspost('/Admin/Customlable/getRankUserListFh', {lableId})

/*
 * 标签管理-自定义标签编辑
 * @constructor jack
 * */
export const customEdit = (name,userId,id) => qspost('/Admin/Customlable/addAndUpdateCustomLableFh', {name,userId,id})

/*
 * 标签管理-自定义标签删除
 * @constructor jack
 * */
export const customDel = (id) => qspost('/Admin/Customlable/delCustomLableFh', {id})


/*
 * 机构信息
  * * @constructor jack
 * */
export const setParentInfo = (logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc) => qspost('Admin/Index/setParentInfoFh', {
    logo,name,rankId,lianxiren,lianxidianhua,addresss,email
    ,website,desc
})

/*
* 信息管理-自定义表单获取
*
* */
export const getInformation = () => qspost('/Admin/user/getUserMoreJsonFh', {})

/*
* 信息管理-自定义表单获取
*
* */
export const getPersonalInformation = () => qspost('/Admin/Personal/getUserMoreJsonFh', {})

/*
* 信息管理-自定义表单提交
*
* */
export const saveInformation = (userMoreJson) => qspost('/Admin/user/addAndEditUserMoreJsonFh', {userMoreJson})

/*
* 信息管理-自定义表单提交
*
* */
export const savePersonalInformation = (userMoreJson) => qspost('/Admin/Personal/addAndEditUserMoreJsonFh', {userMoreJson})


/*会员说明*/

/*
 * 会员说明-详情
 * @constructor jack
 * */
export const explainDetail = (type) => qspost('/Admin/Article/getInfoFh', {type})

/*
 * 会员说明-提交
 * @constructor jack
 * */
export const explainEdit = (type,content) => qspost('/Admin/Article/editFh', {type,content})


/*
 * 证书管理-证书展示
 * @constructor jack
 * */
export const certificateShow = (userType) => qspost('/Admin/zhengshu/getZhengShuBaseFh', {userType})

/*
 * 证书管理-证书上传
 * @constructor jack
 * */
export const certificateUp = () => qspost('/Admin/zhengshu/getZhengShuBaseFh', {})

/*
 * 证书管理-证书保存
 * @constructor jack
 * */
export const certificateSave = (type,fileUrl,userType) => qspost('/Admin/zhengshu/saveZhengShuBaseFh', {type,fileUrl,userType})


/*会员管理*/

/*会员管理*/

/*
 * 会员管理-列表
 * @constructor jack
 * */
export const membersList = (page,limit,start_time,end_time,address,keyword,rank_id,status,time,is_locking,order,preserve_type=0) => qspost('/Admin/User/getListFh', {
    page,limit,start_time,end_time,address,keyword,rank_id,status,time,is_locking,order,preserve_type})


/*
 * 会员管理-列表
 * @constructor jack
 * */
export const membersPersonalList = (page,limit,start_time,end_time,keyword,rank_id,status,time,is_locking,order,preserve_type=0) => qspost('/Admin/Personal/getListFh', {
    page,limit,start_time,end_time,keyword,rank_id,status,time,is_locking,order,preserve_type})

/*
 * 会员管理-会员锁定与解锁
 * @constructor jack
 * */
export const memberSet = (user_id,state) => qspost('/Admin/User/setStateFh', {user_id,state})

/*
 * 会员管理-会员锁定与解锁
 * @constructor jack
 * */
export const memberSetOut = (user_id,state) => qspost('/Admin/User/setOutFH', {user_id,state})


/*
 * 会员管理-会员证书
 * @constructor jack
 * */
export const memberCertificate = (userId) => qspost('/Admin/User/getUserZhengShuFh', {userId})


/*
 * 会员管理-会员删除
 * @constructor jack
 * */
export const memberDel = (id) => qspost('/Admin/User/delFh', {id})


/*
 * 会员管理-会员添加
 * @constructor jack
 * */
export const memberAdd = (userMoreJson,end_time,user_id,userType,preserve_type=0) => qspost('/Admin/User/setUserFh', {userMoreJson,end_time,user_id,userType,preserve_type})

/*
 * 会员管理-会员添加
 * @constructor jack
 * */
export const setUserZhengShuCode = (userId,zhengShuCode) => qspost('/Admin/User/setUserZhengShuCode', {userId,zhengShuCode})


/*
 * 会员管理-会员详情
 * @constructor jack
 * */
export const memberDetail = (user_id) => qspost('/Admin/User/getDetailFh', {user_id})


/*
 * 会员管理-审核列表
 * @constructor jack
 * */
export const checkList = (page,limit,name,rank_id) => qspost('/Admin/User/getFHUserCheckList', {page,limit,name,rank_id})



/*
 * 会员管理-会员审核详情
 * @constructor jack
 * */
export const getApplyUserData = (id) => qspost('/Admin/User/getApplyFHUserData', {id})

/*
 * 会员管理-会员审核详情修改
 * @constructor jack
 * */
export const memberApplyEdit = (userMoreJson,id,endTime,
                                zhengShuCode) => qspost('/Admin/User/setApplyFHUser', {userMoreJson,id,endTime,
    zhengShuCode})

/*
 * 会员管理-会员审核通过/拒绝
 * @constructor jack
 * */
export const memberCheck = (id,status,examineMsg,endTime,
                            zhengShuCode) => qspost('/Admin/User/setFHUserCheck', {id,status,examineMsg,endTime,
    zhengShuCode})





/*
 * 机构动态列表
  * * @constructor jack
 * */
export const getActiveList = (page, limit, keyword) => qspost('admin/Noticeactive/queryFh', {page, limit, keyword})

/*
 *  首页动态详情
 * @constructor jack
 * */

export const getHomeActiveDetail = (id) => qspost('home/Noticeactive/detailFh', {id})


/*
 *  首页动态
 * @constructor jack
 * */

export const getActives = (page, limit, keyword) => qspost('home/Noticeactive/queryFh', {page, limit, keyword})


/*
 * 删除动态
  * * @constructor jack
 * */
export const delActive = (ids) => qspost('admin/Noticeactive/delFh', {ids})

/*
 * 添加动态
  * * @constructor jack
 * */
export const addActive = (title,content,images) => qspost('admin/Noticeactive/addFh', {
    title,content,images
})


/*
 * 编辑动态
  * * @constructor jack
 * */
export const editActive = (id,title,content,images) => qspost('admin/Noticeactive/editFh', {
    id,title,content,images
})

/*
 * 动态
  * * @constructor jack
 * */
export const getActiveDetail = (id) => qspost('admin/Noticeactive/detailFh', {id})


/*
 * 服务列表
  * * @constructor jack
 * */
export const getServerList = () => qspost('Admin/Server/getTypeListFh', {})

/*
 * 编辑提交数据
  * * @constructor jack
 * */
export const editServer = (id,title,desc,label,son_title,son_content,son_id) => qspost('Admin/Server/editFh', {id,title,desc,label,son_title,son_content,son_id})

/*
 * 服务-详情
  * * @constructor jack
 * */
export const getServerDetail = (id) => qspost('Admin/Server/detailFh', {id})

/*
 * 服务-详情
  * * @constructor jack
 * */
export const getServerProjectList = (sid,rankId,searchName) => qspost('Admin/server/getAppointApplyBySidFh', {sid,rankId,searchName})

/*
 * 删除服务列表
  * * @constructor jack
 * */
export const delServer = (id) => qspost('Admin/Server/delFh', {id})

/*
 * 删除记录列表
  * * @constructor jack
 * */
export const delApply = (id) => qspost('Admin/Server/delApplyFh', {id})

/*
 * 删除记录列表
  * * @constructor jack
 * */
export const delAllApply = (serverId) => qspost('Admin/Server/delApplyAllFh', {serverId})

/*
 * 处理记录
  * * @constructor jack
 * */
export const changeServerApply = (id,server_title,server_content,server_num
) => qspost('Admin/Server/changeServerApplyFh', {id,server_title,server_content,server_num})

/*
 *  服务中心列表
 * @constructor jack
 * */

export const getHomeServerList = () => qspost('Home/Server/getListFh', {})

/*
 *  服务中心申请记录
 * @constructor jack
 * */

export const getServerRecord = () => qspost('Home/Server/myApplyServerListFh', {})

/*
 *  服务中心列表详情
 * @constructor jack
 * */

export const getHomeServerDetail = (id) => qspost('Home/Server/detailFh', {id})

/*
 *  活服务中心列表详情服务申请
 * @constructor jack
 * */

export const applyServer = (id,content) => qspost('Home/Server/addApplyFh', {id,content})

/*
 * 会员服务排序
  * * @constructor jack
 * */
export const sortServer = (id,sort) => qspost('Admin/Server/setSortFh', {id,sort})


/*
 *  首页活动会议列表
 * @constructor jack
 * */

export const getMeetings = (status,type,page,limit) => qspost('Home/Meeting/getListFh', {status,type,page,limit})



/*
 *  分会 - 获得自己的机构子管理 - 总会
 * */
export const getSonAdmin = (searchName) => qspost('/admin/User/getSonAdminFh', {searchName})

/*
 * 分会 - 添加自己的机构子管理 - 总会
 * */
export const addSonAdmin = (id,name,account,password,power = '') => qspost('/admin/User/addSonAdminFh', {id,name,account,password,power})

/*
 *  分会 - 删除自己的机构子管理 - 总会
 * */
export const delSonAdmin = (id) => qspost('/admin/User/delSonAdminFh', {id})



/*
 *  修改密码 - 功能\

 * */
export const updatePassword = (fenhui_id,oldpass,newpass,repass) => qspost('/Home/User/setFhPase', {fenhui_id,oldpass,newpass,repass})





/*
 * 支付列表
  * * @constructor jack
 * */
export const getOrderList = (search,page,limit) => qspost('admin/order/queryFh', {search,page,limit})


/*
 * 支付状态
  * * @constructor jack
 * */
export const setIsPayState = (order_number,is_pay) => qspost('admin/order/setIsPayStateFh', {order_number,is_pay})


/*
 * 开票状态
  * * @constructor jack
 * */
export const setInvoiceState = (order_number,invoice_state) => qspost('admin/order/setInvoiceStateFh', {order_number,invoice_state})


/*
 * 发票管理列表
  * * @constructor jack
 * */
export const getInvoiceList = (start_time,end_time,page,limit) => qspost('Admin/User/getInvoiceListFh', {start_time,end_time,page,limit})


/*
 * 微信商户信息
  * * @constructor jack
 * */
export const getWxPayInfo = () => qspost('admin/wechat/wechatConfig_indexFh', {})

/*
 * 设置微信商户信息
  * * @constructor jack
 * */
export const setWxPayInfo = (wx_appid,wx_mch_id,wx_apikey) => qspost('admin/wechat/wechatConfig_updateFh', {wx_appid,wx_mch_id,wx_apikey})


/*
 *  缴费信息列表
 * @constructor jack
 * */

export const getPayLog = (user_id) => qspost('admin/User/getPayLogFh', {user_id})



/*
 * 客服列表
  * * @constructor jack
 * */
export const getKefuList = () => qspost('Admin/Index/getKefuListFh', {})

/*
 * 删除客服
  * * @constructor jack
 * */
export const delKefu = (id) => qspost('Admin/Index/delKefuFh', {id})

/*
 * 添加客服
  * * @constructor jack
 * */
export const addKefu = (id,name,phone) => qspost('Admin/Index/setKefuFh', {id,name,phone})


/*
 * 常见问题列表
  * * @constructor jack
 * */
export const getQuestionList = (page, limit, keyword) => qspost('Admin/Commonproblem/getListFh', {page, limit, keyword})

/*
 * 添加/修改常见问题
  * * @constructor jack
 * */
export const addQuestion = (id, title, content,key_word) => qspost('Admin/Commonproblem/setInfoFh', {id, title, content,key_word})


/*
 * 删除常见问题
  * * @constructor jack
 * */
export const delQuestion = (id) => qspost('Admin/Commonproblem/delFh', {id})


/*
 * 意见反馈列表
  * * @constructor jack
 * */
export const getMessageList = (page, limit) => qspost('Admin/Message/getListFh', {page, limit})

/*
 * 删除意见反馈
  * * @constructor jack
 * */
export const replyMessage = (id,content) => qspost('Admin/Message/remarkFh', {id,content})

/*
 * 删除意见反馈
  * * @constructor jack
 * */
export const delMessage = (id) => qspost('Admin/Message/delFh', {id})

/*
 * 证书管理-证书展示
 * @constructor jack
 * */
export const getFhPinShu = () => qspost('/home/user/getPinShu', {})


/*
 *  获取 会员说明 - 机构
 * @constructor jack
 * */
export const getMemberClassifyList = () => qspost('/admin/Article/getListFh', {})

/*
 * 添加/修改 文章分类 - 机构
 * @constructor jack
 * */
export const createAndUpdateArticleType = (id,name) => qspost('/admin/Article/createAndUpdateArticleTypeFh', {id,name})

/*
 *  删除 文章分类 - 机构
 * @constructor jack
 * */
export const delArticleType = (id) => qspost('/admin/Article/delArticleTypeFh', {id})

/*
 *  删除 文章 - 机构
 * @constructor jack
 * */
export const delArticle = (id) => qspost('/admin/Article/delArticleFh', {id})

/*
 * 添加 文章 - 机构
 * @constructor jack
 * */
export const editArticle = (id,type,title,content) => qspost('/admin/Article/editFh', {id,type,title,content})

/*
 * 文章详情  -
 * @constructor jack
 * */
export const getInfoArticle = (id) => qspost('/admin/Article/getInfoFh', {id})

/*
 * 添加 文章 - 机构
 * @constructor jack
 * */
export const saveBasesArticleData = (oid,fid,type,title,content) => qspost('/admin/Article/saveBasesArticleData', {oid,fid,type,title,content})

/*
 * 文章详情  -
 * @constructor jack
 * */
export const getBasesArticleData = (oid,fid,type) => qspost('/admin/Article/getBasesArticleData', {oid,fid,type})





/*
 * 文章详情  -
 * @constructor jack
 * */
export const getFhPower = (id) => qspost('/admin/user/getFhPower', {id})

export const getFhSonPower = (id) => qspost('/admin/user/getSonPower', {id})

/*
 * 自定义统计的json信息
 * */
export const customFieldStatistics = (id) => qspost('/admin/Tongji/customFieldStatistics', {id})

/*
 * 添加缴费记录
 * */
export const setUserEndTime = (userId,startTime,endTime,payAmount) => qspost('/Admin/User/setUserEndTime', {userId,startTime,endTime,payAmount})

/*
 * 删除缴费记录
 * */
export const delUserPayLogData = (id) => qspost('/Admin/User/delUserPayLogData', {id})


/*
 *  用户证书信息详情
 * */
export const getUserCertDetail = (user_id) => qspost('/admin/user_cert/detail', {user_id})

/*
 *  用户证书信息更新信息
 * */
export const upUserCertDetail = (user_id,cert_name, cert_content, cert_code, cert_company,
                                 cert_date) => qspost('/admin/user_cert/update', {user_id,cert_name, cert_content, cert_code, cert_company, cert_date})


/*
 *  管理端查询网站基础设置
 * */
export const getWebSetInfo = () => qspost('/admin/Webset/getWebSetInfoFH', {})

/*
 *  管理端编辑网站基础设置
 * */
export const setWebSet = (showGerenRegister,showOrgRegister, registerPay,smsNotice
) => qspost('/admin/Webset/setWebSetFH', {showGerenRegister,showOrgRegister, registerPay,smsNotice})


/*
 *  分会登陆加积分
 * */
export const addFenHuiIntegralRes = (fenhui_id) => qspost('/home/Login/addFenHuiIntegralRes', {fenhui_id})


/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importUserFH_optimized = (op_type,file_path,page,limit) => qspost('Admin/User/importUserFH_optimized', {op_type,file_path,page,limit})

/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importUpdateUserFH_optimized = (op_type,file_path,page,limit) => qspost('Admin/User/importUpdateUserFH_optimized', {op_type,file_path,page,limit})


/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importPersonalUserFH_optimized = (op_type,file_path,page,limit) => qspost('Admin/Personal/importUserFH_optimized', {op_type,file_path,page,limit})

/*
 *  批量导入会员
 * op_type 2  执行导入
 * */

export const importUpdatePersonalUserFH_optimized = (op_type,file_path,page,limit) => qspost('Admin/Personal/importUpdateUserFH_optimized', {op_type,file_path,page,limit})
